export default {"src":"/_next/static/media/patio-narroline.b485c36a.svg","height":1000,"width":1000};